import { Routes, Route } from 'react-router-dom';
import { LiveConsole } from './LiveConsole';
import { StreamingLandingGate } from '../streaming/StreamingLandingGate';

/**
 * Live Transcoding (live media streaming) module, per provisioned service.
 *
 *   /services/live/:serviceId → console for that live-stream service
 *   /services/live              → landing gate: redirects into the console
 *                                     when the org already has a Penguin service,
 *                                     otherwise shows the activation hero.
 */
export function LivePage() {
  return (
    <Routes>
      <Route path=":serviceId/*" element={<LiveConsole />} />
      <Route index element={<StreamingLandingGate provider="penguin" />} />
    </Routes>
  );
}

export default LivePage;
